import { template_zh_cn } from "./template";

import { credentials_zh_cn } from "./credentials";
import { sequence_detail_steps_zh_cn } from "./detail_steps";
import { sequence_detail_settings_zhHans } from "./detail_settings";
import { sequence_detail_logs_zh } from "./detail_logs";
import { sequence_detail_targets_zhHans } from "./detail_targets";
import { sequence_detail_report_zhCN } from "./detail_report";

import { sequence_wizard_zh_cn } from "./wizard";
export default {
  sequence_main_timeout_title:
    "设定在 {datetime} 启用。您可以随时在下方重新安排。",

  /** tabs */
  sequence_tab_overview: "概览",
  sequence_tab_templates: "模板",
  sequence_tab_analytics: "分析",
  sequence_tab_meetings: "会议",
  sequence_tab_credentials: "凭证",
  sequence_tab_settings: "设置",

  /** aside */
  sequence_overview_aside_create_new_label: "创建新标签",
  sequence_overview_labels_total: "0 工作流程 | 1 工作流程 | {count} 工作流程",

  /** label form */
  sequence_overview_label_create_dialog_name: "新建标签",
  sequence_overview_label_edit_dialog_name: "重命名标签",
  sequence_overview_label_create_dialog_input_label: "请输入新标签名称",
  sequence_overview_label_edit_dialog_input_label: "请输入标签名称",
  sequence_overview_label_create_dialog_input_oplaceholder: "输入新标签名称",
  sequence_overview_label_edit_dialog_input_placeholder: "输入标签名称",
  create_sequence_label_success: "标签已创建",
  create_sequence_label_failed: "创建失败",
  update_sequence_label_success: "更新成功",
  update_sequence_label_failed: "更新失败",

  /** filters */
  sequence_overview_filters_creator: "创建者",
  sequence_overview_filters_label: "标签",
  sequence_overview_filters_starred: "加星",
  sequence_overview_filters_state: "状态",

  sequence_filter_status_active: "启用",
  sequence_filter_status_inactive: "未启用",

  /** table */
  sequence_overview_table_label_panel_empty:
    "您还没有任何标签。点击“⊕”按钮创建第一个标签并开始整理！",
  sequence_overview_label_panel_search_placeholder: "搜索标签",
  add_label_to_sequence_successfully: "添加成功",
  add_label_to_sequence_failed: "添加失败",
  remove_label_from_sequence_successfully: "移除成功",
  remove_label_from_sequence_failed: "移除失败",

  sequence_overview_table_name_sequence_name: "工作流程名称",
  sequence_overview_table_name_people: "联系人",
  sequence_overview_table_name_click_rate: "点击率",
  sequence_overview_table_name_open_rate: "开启率",
  sequence_overview_table_name_reply_rate: "回复率",
  sequence_overview_unsave_count:
    "未选中任何工作流程 | 已选中一个工作流程 | 已选中 {count} 个工作流程",

  /** create sequence */
  sequence_overview_create_sequence_dialog_name: "新建工作流程",
  sequence_overview_create_sequence_dialog_input_label: "请输入工作流程名称",
  sequence_overview_create_sequence_dialog_input_placeholder: "工作流程名称",

  /** detail empty */
  sequence_detail_error_title: "哎呀！我们无法获取数据。",
  sequence_detail_error_desc:
    "链接可能不正确或数据不可用。请检查网址或更换选择后重试。",
  sequence_detail_error_back: "返回工作流程列表",

  /** detail header */
  sequence_detail_delete: "删除此工作流程",
  sequence_detail_delete_dialog_title: "删除工作流程",
  sequence_detail_delete_dialog_subtitle:
    "这将删除整个工作流程，包括所有设置和数据。",
  sequence_detail_delete_dialog_desc:
    "删除后，该工作流程无法恢复。您确定要继续吗？",

  /** detail nav */
  sequence_detail_nav_inbox: "收件箱",
  sequence_detail_nav_steps: "步骤",
  sequence_detail_nav_report: "报告",
  sequence_detail_nav_analytics: "分析",
  sequence_detail_nav_prospects: "潜在客户",
  sequence_detail_nav_settings: "设置",
  sequence_detail_nav_logs: "日志",
  sequence_detail_nav_interactions: "互动",

  /** detail step canvas */
  sequence_detail_workflow_time_delay: "延迟",
  sequence_detail_workflow_time_monitor: "监控",
  sequence_detail_workflow_time_run_immediately: "立即执行",
  sequence_detail_steps_add_first_step: "添加第一个步骤...",

  /** detail step canvas create node */
  sequence_detail_workflow_create_node_level1_title: "接下来会发生什么？",
  sequence_detail_workflow_create_node_level2_title: "选择渠道",
  sequence_detail_workflow_create_node_level3_title: "选择条件/操作类型",

  /** detail step setting panel credential */
  sequence_detail_setting_credential_label: "凭证：",
  sequence_detail_setting_credential_primary_flag: "主用",
  sequence_detail_setting_credential_primary_opeator: "设为主用",
  sequence_workflow_unsave_changes_title: "未保存的更改",
  sequence_workflow_unsave_changes_desc:
    "有未保存的更改。您可以保存更改或离开此页面并放弃更改。",
  leave: "离开",
  discard: "放弃",
  sequence_workflow_version_unsaved_changes_description:
    "当前版本有未保存的更改。您可以返回编辑或保存更改。",
  sequence_workflow_version_invalid_dialog_title: "当前流程图中有未验证的字段",
  sequence_workflow_version_invalid_dialog_primary_button: "返回当前版本",
  sequence_workflow_version_invalid_dialog_description:
    "当前版本中有未验证的字段。您可以返回更新这些字段或放弃更改。",
  back: "返回",
  editor_toolbar_image_upload: "上传",
  editor_toolbar_image_url: "链接",
  choose_file: "选择文件",
  to_upload: "上传",
  editor_toolbar_image_popover_url_label: "图片链接",
  insert: "插入",

  set_schedule: "设置计划时间",
  sequence_main_schedule_title: "安排工作流程",
  start_now: "立即开始",
  schedule_start: "计划开始时间",
  activate_sequence: "激活工作流程",
  sequence_no_credentials_banner_title:
    "连接您的邮箱或消息账号，以便通过 Pubrio 发送工作流程",
  sequence_no_credentials_banner_title_suffix: " · 少于 5 分钟",
  sequence_no_credentials_banner_desc:
    "开始或发送任何工作流程前，必须先完成此设置。",
  sequence_no_credentials_banner_button: "连接发送账号",
  sequence_detail_out_of_schedule_popup_message:
    "工作流程已启用，但当前不在发送时段内。系统暂不会发送任何消息。发送时段为 {0}。将于 {1} 恢复发送。",
  sequence_list_out_of_schedule_popup_message:
    "提醒：当前不在您的发送时段内（{0}）。工作流程会先启用，但首条消息将于 {1} 才会发出。",
  dismiss: "关闭",
  edit_schedule: "编辑发送时段",
  broken_steps_popup_message:
    "默认版本中某些步骤不完整 — 修复后才能激活工作流程。",
  broken_step_save_warning_title: "保存为草稿？",
  broken_step_save_warning_desc_1: "某些步骤尚未完成。",
  broken_step_save_warning_desc_2:
    "您可以先保存为草稿并稍后回来继续编辑，但在所有步骤完成之前，此工作流程无法激活。",
  broken_step_save_warning_primary_button_text: "保存为草稿",
  broken_step_save_warning_default_button_text: "继续编辑",
  broken_step_disable_activation_warning_title: "保存不完整步骤？",
  broken_step_disable_activation_warning_primary_button_text: "保存并暂停",
  broken_step_disable_activation_warning_default_button_text: "继续编辑",
  broken_step_disable_activation_warning_desc_1: "此工作流程当前处于激活状态。",
  broken_step_disable_activation_warning_desc_2:
    "立即保存将使其暂停，直到所有步骤完成并重新激活。",
  ...template_zh_cn,
  ...credentials_zh_cn,
  ...sequence_detail_steps_zh_cn,
  ...sequence_detail_settings_zhHans,
  ...sequence_detail_logs_zh,
  ...sequence_detail_targets_zhHans,

  ...sequence_detail_report_zhCN,
  ...sequence_wizard_zh_cn,
};
